// Mock data for FesX BioResearch Labs Australia
// NOTE: All data here is MOCKED for the frontend-only build.

export const VIALS = [
  "https://images.unsplash.com/photo-1590845947372-4e494e15adee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxwZXB0aWRlJTIwdmlhbHxlbnwwfHx8d2hpdGV8MTc4MzA1NTc0MHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1716972270514-297197c9ff91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxwZXB0aWRlJTIwdmlhbHxlbnwwfHx8d2hpdGV8MTc4MzA1NTc0MHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1554475900-0a0350e3fc7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxsYWJvcmF0b3J5JTIwdmlhbHxlbnwwfHx8d2hpdGV8MTc4MzA1NTc0MHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1554475901-4538ddfbccc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxsYWJvcmF0b3J5JTIwdmlhbHxlbnwwfHx8d2hpdGV8MTc4MzA1NTc0MHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1595500381966-eee2034aae48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5JTIwdmlhbHxlbnwwfHx8d2hpdGV8MTc4MzA1NTc0MHww&ixlib=rb-4.1.0&q=85",
];

export const LAB_IMAGES = {
  hero: "https://customer-assets-jt897jd0.emergentagent.net/job_fesx-peptides/artifacts/ezi4kxru_Copilot_20260722_131403.png",
  lab2: "https://customer-assets-jt897jd0.emergentagent.net/job_fesx-peptides/artifacts/stl7nkcn_Fesx%20pep%20lab.png",
  lab3: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFifGVufDB8fHxibHVlfDE3ODMwNTU3NDB8MA&ixlib=rb-4.1.0&q=85",
};

export const CATEGORIES = [
  { slug: "all", name: "All Products" },
  { slug: "metabolic", name: "Metabolic Research" },
  { slug: "growth-hormone", name: "Growth Hormone Research" },
  { slug: "tissue-repair", name: "Tissue Repair Research" },
  { slug: "nootropic", name: "Nootropic Peptides" },
  { slug: "skin-cellular", name: "Skin & Cellular Research" },
  { slug: "mitochondrial", name: "Mitochondrial Research" },
  { slug: "melanocortin", name: "Melanocortin Agonists" },
  { slug: "lab-supplies", name: "Lab Supplies" },
];

const img = (i) => VIALS[i % VIALS.length];

export const PRODUCTS = [
  {
    id: "reta-10mg", name: "Retatrutide (10mg)", sku: "FSX-007-10MG", category: "metabolic",
    price: 144.99, stock: "in-stock", popularity: 98, purity: "99.4%", size: "10 mg", image: img(0),
    short: "Triple-agonist research peptide (GLP-1 / GIP / glucagon).",
    description: "Retatrutide is a triple-receptor agonist research compound investigated in metabolic signalling studies. Supplied lyophilised in a sealed vial with batch-level HPLC verification. For in-vitro laboratory research only.",
  },
  {
    id: "reta-20mg", name: "Retatrutide (20mg)", sku: "FSX-024-20MG", category: "metabolic",
    price: 229.99, stock: "out-of-stock", popularity: 90, purity: "99.4%", size: "20 mg", image: img(1),
    short: "Higher-capacity triple-agonist research vial.",
    description: "Retatrutide (20mg) higher-capacity vial for extended research protocols. Lyophilised powder, HPLC verified per batch. For in-vitro laboratory research only.",
  },
  {
    id: "reta-30mg", name: "Retatrutide (30mg)", sku: "FSX-019-30MG", category: "metabolic",
    price: 329.99, stock: "in-stock", popularity: 88, purity: "99.4%", size: "30 mg", image: img(2),
    short: "Triple-agonist research peptide, 30mg vial.",
    description: "Retatrutide (30mg) supplied lyophilised with a published Certificate of Analysis. For in-vitro laboratory research only.",
  },
  {
    id: "tirzepatide-20mg", name: "Tirzepatide (20mg)", sku: "FSX-021-20MG", category: "metabolic",
    price: 249.99, stock: "in-stock", popularity: 95, purity: "99.5%", size: "20 mg", image: img(3),
    short: "Dual GIP/GLP-1 receptor agonist research compound.",
    description: "Tirzepatide is a dual-agonist research peptide widely studied in metabolic pathway research. HPLC verified, lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "tirzepatide-40mg", name: "Tirzepatide (40mg)", sku: "FSX-021-40MG", category: "metabolic",
    price: 343.99, compareAt: 429.99, stock: "in-stock", popularity: 85, purity: "99.5%", size: "40 mg", image: img(4),
    short: "Dual-agonist research compound, value vial.",
    description: "Tirzepatide (40mg) value vial for extended research. Third-party HPLC tested. For in-vitro laboratory research only.",
  },
  {
    id: "cagrilintide-5mg", name: "Cagrilintide (5mg)", sku: "FSX-039-5MG", category: "metabolic",
    price: 129.99, stock: "in-stock", popularity: 70, purity: "99.1%", size: "5 mg", image: img(0),
    short: "Long-acting amylin analogue research peptide.",
    description: "Cagrilintide (5mg) amylin-analogue research compound. Lyophilised, batch verified. For in-vitro laboratory research only.",
  },
  {
    id: "aod-9604-5mg", name: "AOD-9604 (5mg)", sku: "FSX-034-5MG", category: "metabolic",
    price: 99.99, stock: "in-stock", popularity: 66, purity: "99.0%", size: "5 mg", image: img(1),
    short: "Modified GH fragment (176-191) research peptide.",
    description: "AOD-9604 (5mg) research compound derived from the GH fragment. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "tesamorelin-10mg", name: "Tesamorelin (10mg)", sku: "FSX-030-10MG", category: "metabolic",
    price: 145.99, stock: "in-stock", popularity: 74, purity: "99.2%", size: "10 mg", image: img(2),
    short: "GHRH analogue research peptide.",
    description: "Tesamorelin (10mg) growth-hormone-releasing hormone analogue for research use. Lyophilised, CoA on file. For in-vitro laboratory research only.",
  },
  {
    id: "bpc-157-10mg", name: "BPC-157 (10mg)", sku: "FSX-011-10MG", category: "tissue-repair",
    price: 94.99, stock: "in-stock", popularity: 97, purity: "99.6%", size: "10 mg", image: img(3),
    short: "Body-protection compound, tissue-repair research.",
    description: "BPC-157 is a widely-studied pentadecapeptide used in soft-tissue and structural repair research. HPLC verified per batch. For in-vitro laboratory research only.",
  },
  {
    id: "bpc-tb500-10mg", name: "BPC-157 + TB-500 (10mg)", sku: "FSX-018-10MG", category: "tissue-repair",
    price: 109.99, stock: "pre-order", popularity: 89, purity: "99.3%", size: "10 mg", image: img(4),
    short: "Repair research blend of BPC-157 and TB-500.",
    description: "A combined repair-research blend of BPC-157 and TB-500 supplied in a single vial. Lyophilised, batch tested. For in-vitro laboratory research only.",
  },
  {
    id: "tb-500-10mg", name: "TB-500 (10mg)", sku: "FSX-015-10MG", category: "tissue-repair",
    price: 129.99, stock: "pre-order", popularity: 78, purity: "99.2%", size: "10 mg", image: img(0),
    short: "Thymosin Beta-4 fragment repair research peptide.",
    description: "TB-500 (10mg) research peptide used in structural repair studies. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "kpv-10mg", name: "KPV (10mg)", sku: "FSX-022-10MG", category: "tissue-repair",
    price: 89.99, stock: "in-stock", popularity: 62, purity: "99.0%", size: "10 mg", image: img(1),
    short: "Tripeptide fragment used in repair research.",
    description: "KPV (10mg) alpha-MSH derived tripeptide for repair and signalling research. Lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "cjc-ipa-10mg", name: "CJC-1295 (no DAC) + Ipamorelin (10mg)", sku: "FSX-017-10MG", category: "growth-hormone",
    price: 129.99, stock: "in-stock", popularity: 91, purity: "99.4%", size: "10 mg", image: img(2),
    short: "GH-axis research blend for synergy studies.",
    description: "CJC-1295 (no DAC) combined with Ipamorelin, a popular GH-axis research blend. Batch HPLC tested. For in-vitro laboratory research only.",
  },
  {
    id: "ipamorelin-10mg", name: "Ipamorelin (10mg)", sku: "FSX-023-10MG", category: "growth-hormone",
    price: 89.99, stock: "pre-order", popularity: 80, purity: "99.3%", size: "10 mg", image: img(3),
    short: "Selective GH secretagogue research peptide.",
    description: "Ipamorelin (10mg) selective growth-hormone secretagogue research peptide. Lyophilised, CoA on file. For in-vitro laboratory research only.",
  },
  {
    id: "cjc-no-dac-10mg", name: "CJC-1295 (no DAC) (10mg)", sku: "FSX-016-10MG", category: "growth-hormone",
    price: 104.99, stock: "pre-order", popularity: 72, purity: "99.2%", size: "10 mg", image: img(4),
    short: "GHRH analogue (no DAC) research peptide.",
    description: "CJC-1295 without DAC, a GHRH analogue for GH-axis research. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "dsip-10mg", name: "DSIP (10mg)", sku: "FSX-032-10MG", category: "growth-hormone",
    price: 75.99, compareAt: 95.99, stock: "pre-order", popularity: 55, purity: "99.0%", size: "10 mg", image: img(0),
    short: "Delta sleep-inducing peptide research compound.",
    description: "DSIP (10mg) neuropeptide studied in sleep and signalling research. Lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "semax-10mg", name: "Semax (10mg)", sku: "FSX-008-10MG", category: "nootropic",
    price: 69.99, stock: "in-stock", popularity: 84, purity: "99.1%", size: "10 mg", image: img(1),
    short: "ACTH-derived nootropic research peptide.",
    description: "Semax (10mg) heptapeptide studied in cognition and neuroprotection research. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "selank-10mg", name: "Selank (10mg)", sku: "FSX-013-10MG", category: "nootropic",
    price: 94.99, stock: "in-stock", popularity: 68, purity: "99.1%", size: "10 mg", image: img(2),
    short: "Anxiolytic nootropic research peptide.",
    description: "Selank (10mg) synthetic peptide studied in anxiolytic and cognitive research. Lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "ghk-cu-50mg", name: "GHK-Cu (50mg)", sku: "FSX-010-50MG", category: "skin-cellular",
    price: 99.99, stock: "in-stock", popularity: 87, purity: "99.5%", size: "50 mg", image: img(3),
    short: "Copper tripeptide skin & cellular research.",
    description: "GHK-Cu (50mg) copper-binding tripeptide widely studied in skin and cellular repair research. HPLC verified per batch. For in-vitro laboratory research only.",
  },
  {
    id: "glow-50mg", name: "GLOW Peptide Blend (50mg)", sku: "FSX-012-GLOW", category: "skin-cellular",
    price: 168.99, stock: "in-stock", popularity: 82, purity: "99.3%", size: "50 mg", image: img(4),
    short: "Copper-peptide research blend (GHK-Cu based).",
    description: "GLOW is a copper-peptide research blend combining GHK-Cu and complementary tripeptides. Batch tested with CoA. For in-vitro laboratory research only.",
  },
  {
    id: "glutathione-600mg", name: "Glutathione (600mg)", sku: "FSX-033-600MG", category: "skin-cellular",
    price: 79.99, stock: "in-stock", popularity: 64, purity: "99.0%", size: "600 mg", image: img(0),
    short: "Antioxidant tripeptide research compound.",
    description: "Glutathione (600mg) antioxidant tripeptide used in cellular research. Lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "epitalon-10mg", name: "Epitalon (10mg)", sku: "FSX-027-10MG", category: "skin-cellular",
    price: 79.99, stock: "in-stock", popularity: 60, purity: "99.1%", size: "10 mg", image: img(1),
    short: "Telomerase-related longevity research peptide.",
    description: "Epitalon (10mg) tetrapeptide studied in longevity and cellular ageing research. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "nad-500mg", name: "NAD+ (500mg)", sku: "FSX-002-500MG", category: "mitochondrial",
    price: 129.99, stock: "in-stock", popularity: 79, purity: "99.4%", size: "500 mg", image: img(2),
    short: "Cellular energy metabolism research compound.",
    description: "NAD+ (500mg) coenzyme studied in mitochondrial and cellular energy research. Lyophilised. For in-vitro laboratory research only.",
  },
  {
    id: "mots-c-10mg", name: "MOTS-C (10mg)", sku: "FSX-014-10MG", category: "mitochondrial",
    price: 94.99, stock: "in-stock", popularity: 73, purity: "99.2%", size: "10 mg", image: img(3),
    short: "Mitochondrial-derived research peptide.",
    description: "MOTS-C (10mg) mitochondrial-derived peptide studied in metabolic regulation research. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "ss-31-10mg", name: "SS-31 (10mg)", sku: "FSX-020-10MG", category: "mitochondrial",
    price: 89.99, compareAt: 119.99, stock: "in-stock", popularity: 71, purity: "99.3%", size: "10 mg", image: img(4),
    short: "Mitochondria-targeting research peptide.",
    description: "SS-31 (10mg) mitochondria-targeted research peptide. Lyophilised, batch tested. For in-vitro laboratory research only.",
  },
  {
    id: "5-amino-1mq-50mg", name: "5-Amino-1MQ (50mg)", sku: "FSX-005-50MG", category: "mitochondrial",
    price: 109.99, stock: "in-stock", popularity: 69, purity: "99.0%", size: "50 mg", image: img(0),
    short: "NNMT inhibitor small-molecule research compound.",
    description: "5-Amino-1MQ (50mg) small-molecule research compound studied in metabolic pathways. For in-vitro laboratory research only.",
  },
  {
    id: "melanotan-ii-10mg", name: "Melanotan II (10mg)", sku: "FSX-009-10MG", category: "melanocortin",
    price: 79.99, stock: "low", stockCount: 3, popularity: 83, purity: "99.2%", size: "10 mg", image: img(1),
    short: "Melanocortin agonist research peptide.",
    description: "Melanotan II (10mg) melanocortin-receptor agonist research peptide. HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "melanotan-i-10mg", name: "Melanotan I (10mg)", sku: "FSX-026-10MG", category: "melanocortin",
    price: 79.99, stock: "pre-order", popularity: 61, purity: "99.1%", size: "10 mg", image: img(2),
    short: "Melanocortin agonist research peptide (afamelanotide).",
    description: "Melanotan I (10mg) melanocortin research peptide. Lyophilised, CoA on file. For in-vitro laboratory research only.",
  },
  {
    id: "pt-141-10mg", name: "PT-141 (10mg)", sku: "FSX-035-10MG", category: "melanocortin",
    price: 99.99, stock: "pre-order", popularity: 76, purity: "99.2%", size: "10 mg", image: img(3),
    short: "Bremelanotide melanocortin research peptide.",
    description: "PT-141 (10mg) melanocortin-receptor agonist research peptide (bremelanotide). HPLC verified. For in-vitro laboratory research only.",
  },
  {
    id: "bac-water-10ml", name: "BAC Water (10mL)", sku: "FSX-004-10ML", category: "lab-supplies",
    price: 28.99, stock: "in-stock", popularity: 92, purity: "USP grade", size: "10 mL", image: img(4),
    short: "Bacteriostatic water for reconstitution.",
    description: "Bacteriostatic water (10mL) for laboratory reconstitution of lyophilised research compounds. For laboratory use only.",
  },
  {
    id: "bac-water-3ml", name: "BAC Water (3mL)", sku: "FSX-001-3ML", category: "lab-supplies",
    price: 19.99, stock: "pre-order", popularity: 75, purity: "USP grade", size: "3 mL", image: img(0),
    short: "Bacteriostatic water for reconstitution.",
    description: "Bacteriostatic water (3mL) for laboratory reconstitution. For laboratory use only.",
  },
  {
    id: "insulin-syringes-20pk", name: "Insulin Syringes (20pk)", sku: "FSX-003-20PK", category: "lab-supplies",
    price: 22.99, stock: "in-stock", popularity: 81, purity: "sterile", size: "U-50 · 20pk", image: img(1),
    short: "Sterile lab measurement syringes (20 pack).",
    description: "Sterile insulin syringes (20 pack) for accurate laboratory measurement and handling. For laboratory use only.",
  },
];

export const STOCK_LABELS = {
  "in-stock": { label: "In Stock", tone: "green" },
  "pre-order": { label: "Pre-Order", tone: "amber" },
  "out-of-stock": { label: "Out of Stock", tone: "red" },
  "low": { label: "Low Stock", tone: "amber" },
};

export const TRUST_TICKER = [
  "Trusted AU Source",
  "Same Business Day Dispatch",
  "Local Australian Stock",
  "Shipped Discreetly",
  "High Purity Premium Stock",
  "CoA Every Batch",
];

export const FAQS = [
  { q: "What are these products for?", a: "All products are strictly intended for laboratory research and analytical purposes only. They are not for human or animal consumption." },
  { q: "Do you ship Australia-wide?", a: "Yes. We ship securely to all Australian states and territories via Australia Post Express with tracking provided on every order." },
  { q: "Are Certificates of Analysis available?", a: "Yes. Every batch is independently HPLC tested and a Certificate of Analysis (CoA) is published and linked to each product listing." },
  { q: "What payment methods do you accept?", a: "We accept credit and debit cards, Apple Pay, Google Pay, and cryptocurrency. Crypto orders receive an automatic 10% discount." },
  { q: "How long does shipping take?", a: "Orders placed Mon–Fri before 12pm AEST dispatch the same day. Express delivery is typically 1–4 business days depending on your state." },
  { q: "Can I track my order?", a: "Yes. Once dispatched you receive a tracking number by email, and you can check status anytime via the Track Order page." },
  { q: "What purity standard do you hold?", a: "Every compound is released only after confirming a 99%+ HPLC purity standard, verified per batch by a third-party laboratory." },
  { q: "Who can purchase from FesX?", a: "You must be a qualified researcher aged 18 or older to purchase. All sales are for in-vitro laboratory research only." },
];

export const TESTIMONIALS = [
  { name: "Dr. A. Whitmore", role: "Research Laboratory, NSW", text: "Consistent purity and the batch-level CoAs make documentation for our studies painless. Dispatch is genuinely same-day." },
  { name: "M. Kaur", role: "University Research Group, VIC", text: "The transparency is what sets FesX apart — every vial traces back to a published HPLC result. Reliable and fast." },
  { name: "T. Nguyen", role: "Independent Researcher, QLD", text: "Packaging is discreet and secure, and everything matched the tested vial imagery. Exactly what a research supply should be." },
];

export const SHIPPING_ETA = [
  { code: "NSW", name: "New South Wales", eta: "1–2 days" },
  { code: "VIC", name: "Victoria", eta: "1–2 days" },
  { code: "QLD", name: "Queensland", eta: "1–2 days" },
  { code: "ACT", name: "Australian Capital Territory", eta: "1–2 days" },
  { code: "WA", name: "Western Australia", eta: "2–3 days" },
  { code: "SA", name: "South Australia", eta: "2–3 days" },
  { code: "TAS", name: "Tasmania", eta: "2–3 days" },
  { code: "NT", name: "Northern Territory", eta: "3–4 days" },
];

export const FREE_SHIP_THRESHOLD = 220;
